import { useEffect, useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Grid from "@mui/material/Grid";
import MyHorizontalBarChart from "../chart/MyHorizontalBarChart";

import {
  StripedTableRow,
  StripedTableCell,
  StripedTableHeadCell,
} from "../StripedTable";

const CommServiceTotalsDialog = ({
  student,
  totals,
  dialogOpen,
  setDialogOpen,
  ops = [],
}) => {
  const [_opsByFiscalYear, setOpsByFiscalYear] = useState({
    labels: [],
    series: [],
  });
  const [_opsByType, setOpsByType] = useState({
    labels: [],
    series: [],
  });

  useEffect(() => {
    initOpsByYear();
    initOpsByType();
  }, [ops]);

  const initOpsByType = () => {
    const fyTotalMinutesMap = {};
    for (const op of ops) {
      const typeName = op.typeName;
      if (typeName == null) {
        continue;
      }

      // add to map and increment counter
      if (!fyTotalMinutesMap[typeName]) {
        fyTotalMinutesMap[typeName] = {
          name: typeName,
          minutes: 0,
        };
      }
      fyTotalMinutesMap[typeName].minutes += op.hourNum * 60 + op.minuteNum;
    }

    // loop entries in fyTotalMinutesMap and calculate hours attribute based on minutes attribute / 60
    for (const fyName in fyTotalMinutesMap) {
      fyTotalMinutesMap[fyName].hours = fyTotalMinutesMap[fyName].minutes / 60;
    }

    const labels = Object.keys(fyTotalMinutesMap).sort();
    const series = [labels.map((fyName) => fyTotalMinutesMap[fyName].hours)];

    setOpsByType({ labels, series });
  };

  const initOpsByYear = () => {
    const fyTotalMinutesMap = {};
    for (const op of ops) {
      const fyName = op.fyName;
      if (fyName == null) {
        continue;
      }

      // add to map and increment counter
      if (!fyTotalMinutesMap[fyName]) {
        fyTotalMinutesMap[fyName] = {
          name: fyName,
          minutes: 0,
        };
      }
      fyTotalMinutesMap[fyName].minutes += op.hourNum * 60 + op.minuteNum;
    }

    // loop entries in fyTotalMinutesMap and calculate hours attribute based on minutes attribute / 60
    for (const fyName in fyTotalMinutesMap) {
      fyTotalMinutesMap[fyName].hours = fyTotalMinutesMap[fyName].minutes / 60;
    }

    const labels = Object.keys(fyTotalMinutesMap).sort();
    const series = [labels.map((fyName) => fyTotalMinutesMap[fyName].hours)];

    setOpsByFiscalYear({ labels, series });
  };

  const handleClose = () => {
    setDialogOpen(false);
  };

  return (
    <Dialog onClose={handleClose} open={dialogOpen} fullWidth={true} fullScreen>
      <DialogTitle>
        Totals for {student.last_name}, {student.first_name} ({student.grade})
      </DialogTitle>

      <DialogContent>
        <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
          <AccordionSummary className="accordionTitle">
            Total Hours
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper} sx={{ mt: 0 }}>
              <Table sx={{ width: "100%" }} size="small">
                <TableBody>
                  <StripedTableRow>
                    <StripedTableHeadCell>Pending</StripedTableHeadCell>
                    <StripedTableCell>
                      {Math.floor(totals["s0"] / 60)}h {totals["s0"] % 60}m
                    </StripedTableCell>
                  </StripedTableRow>
                  <StripedTableRow>
                    <StripedTableHeadCell>Approved</StripedTableHeadCell>
                    <StripedTableCell>
                      {Math.floor(totals["s100"] / 60)}h {totals["s100"] % 60}m
                    </StripedTableCell>
                  </StripedTableRow>
                  <StripedTableRow>
                    <StripedTableHeadCell>Rejected</StripedTableHeadCell>
                    <StripedTableCell>
                      {Math.floor(totals["s-100"] / 60)}h {totals["s-100"] % 60}
                      m
                    </StripedTableCell>
                  </StripedTableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={6}>
            <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
              <AccordionSummary className="accordionTitle">
                Hours by Fiscal Year
              </AccordionSummary>
              <AccordionDetails>
                <MyHorizontalBarChart
                  data={_opsByFiscalYear}
                  height={_opsByFiscalYear?.labels?.length * 80 || 180}
                  showLegend={false}
                />
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={6}>
            <Accordion disableGutters sx={{ boxShadow: 1, mt: 2 }} expanded>
              <AccordionSummary className="accordionTitle">
                Hours by Type
              </AccordionSummary>
              <AccordionDetails>
                <MyHorizontalBarChart
                  data={_opsByType}
                  height={_opsByType?.labels?.length * 50 || 180}
                  showLegend={false}
                />
              </AccordionDetails>
            </Accordion>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} variant="outlined">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommServiceTotalsDialog;
